import { sdkLoggerInterface as log } from '../Logger/Logger';
/**
 * [[include:packages/consumer/sdk-browser/src/FlagMgr/README.md]]
 */
export class CoreFlagMgr {
    constructor() {
        this.appStrategies = {};
        this.initDefs = {};
    }
    /**
     * This function is used to set the strategy for a miniapp or a shell, so that when a mini-app or shell calls check flag it knows how to get the appropriate flag value.
     * @param user The User Object
     * @param strategy The type of flag management strategy you would like to register for this miniapp or shell.
     * @param appId What type of application. e.g `nab-x-miniapp-example`. For Shells they are prefixed with `SHELL`
     */
    setFlagStrategy(user, strategy, appId) {
        if (!this.appStrategies[appId]) {
            this.createInitDeferred(appId);
            if (this.isUserValid(user) && this.isStrategyValid(strategy) && appId) {
                this.appStrategies[appId] = strategy;
                this.initStrategy(appId, user);
            }
            else {
                this.initDefs[appId].reject(new Error('All Params must be defined. (user, strategy and appId)'));
            }
        }
        return this.initDefs[appId].promise;
    }
    async initStrategy(appId, user) {
        try {
            await this.appStrategies[appId].initialise(user);
            this.initDefs[appId].resolve();
            log.info(`added flag strategy for appId: ${appId}`);
        }
        catch (e) {
            delete this.appStrategies[appId];
            this.initDefs[appId].reject(e);
        }
    }
    areFlagsReady(appId) {
        return this.appStrategies[appId] ? this.appStrategies[appId].isInitialised : false;
    }
    async whenFlagsReady(appId) {
        return this.createInitDeferred(appId).promise;
    }
    createInitDeferred(appId) {
        if (!this.initDefs[appId]) {
            this.initDefs[appId] = {};
            this.initDefs[appId].promise = new Promise((resolve, reject) => {
                this.initDefs[appId].resolve = resolve;
                this.initDefs[appId].reject = reject;
            });
        }
        return this.initDefs[appId];
    }
    /**
     * Used evaluate a feature flag for the current user.
     * @param appId the miniapp id used to locate the client to use
     * @param flagName name of the flag to check
     * @param defaultValue default value if no match
     */
    checkFlag(appId, flagName, defaultValue) {
        if (this.appStrategies[appId]?.isInitialised) {
            try {
                return this.appStrategies[appId].checkFlag(flagName, defaultValue);
            }
            catch (e) {
                log.error('Something went wrong trying to fetch your flag: ', e);
                return defaultValue;
            }
        }
        log.warn('This miniapp has not set the flag strategy.');
        return defaultValue;
    }
    isUserValid(user) {
        return user && Object.keys(user).length !== 0;
    }
    isStrategyValid(strategy) {
        return strategy && Object.keys(strategy).length !== 0;
    }
}
//# sourceMappingURL=CoreFlagMgr.js.map